import styled from 'styled-components';
import withTransition, { propTypes } from './withTransition';
import Box from '../Box';
var FadeStyled = styled(Box).withConfig({
  displayName: "Fade__FadeStyled",
  componentId: "sc-5ci7rj-0"
})(["opacity:", ";transition:", ";visibility:", ";"], function (props) {
  if (props.state === 'exited' || props.state === 'exiting') {
    return 0;
  }

  if (props.state === 'entering' || props.state === 'entered') {
    return 1;
  }
}, function (props) {
  return "opacity ".concat(props.duration, "ms ").concat(props.easing, " 0ms");
}, function (props) {
  return props.state === 'exited' ? 'hidden' : 'inherit';
});
export var Fade = withTransition(FadeStyled);
Fade.propTypes = propTypes;
Fade.defaultProps = {
  duration: 300
};